// extracted by mini-css-extract-plugin
export default {"box":"box_box__qUZmw","boxContent":"box_boxContent__Iyv+K","title":"box_title__UU4+c","rightOfTitle":"box_rightOfTitle__hi+pF"};